/* LB Update 70: Voice-over-Player mit Wellenform und Transkript.
   Das Transkript ist reine Darstellung: eine Schriftfarbe, keine Hervorhebung,
   nicht anklickbar. Es legt sich beim Oeffnen ueber den Player selbst.
   Kein Fremd-Skript, kein Netzwerkzugriff vor dem ersten Klick.
   Der Ton haengt als <audio preload="none"> im Markup. */
(function () {
  'use strict';
  /* LB Update 291 (Audit S2-012/S2-029): Diese Datei wird mit jedem Produktbereich neu eingebunden (snippets/lb-voiceover.liquid) und lief deshalb bei
     jedem Farbwechsel ohne Neuladen (lb-swatch-wechsel.js) und bei jeder neu geladenen Sektion im Editor erneut - und meldete jedes Mal weitere
     document-Listener an (gemessen: +1 shopify:section:load, +1 lb:produkt-gewechselt je Wechsel). Jetzt: Beim erneuten Lauf nur die schon laufende
     Fassung anstossen (sie baut die neuen Player auf) und beenden. Rueckbau: die beiden Zeilen mit window.lbVoiceoverBereit entfernen. */
  if (window.lbVoiceoverBereit) { try { window.lbVoiceoverBereit(); } catch (e) {} return; }
  window.lbVoiceoverBereit = function () { alle(); };
  function mmss(s) {
    s = Math.max(0, Math.round(s || 0));
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }
  /* LB Update 250 (H2): Knopf-Beschriftung Abspielen/Pause je Sprache der Seite (vorher fest deutsch,
     Pruefbericht 249 F06). Rueckfall Deutsch. */
  var lbVoL = (document.documentElement.lang || 'de').toLowerCase().slice(0, 2);
  var lbVoT = ({
    en: {play: 'Play', pause: 'Pause'},
    nl: {play: 'Afspelen', pause: 'Pauzeren'},
    fr: {play: 'Lire', pause: 'Pause'},
    pl: {play: 'Odtwórz', pause: 'Pauza'},
    it: {play: 'Riproduci', pause: 'Pausa'},
    es: {play: 'Reproducir', pause: 'Pausa'}
  })[lbVoL] || {play: 'Abspielen', pause: 'Pause'};
  var escListe = []; /* LB Update 291 (Audit S2-029): Escape-Handler je Player, siehe init() */
  /* LB Update 291 (Auftrag F06): Instanzregister. Eine Instanz gehoert zu genau einem .lb-vo-Element und wird ueber das Element gefunden
     (WeakMap statt nur Attribut: ein per cloneNode/importNode kopiertes Element traegt data-lb-vo-ready mit, hat aber keine Handler).
     Der einzige Handler ausserhalb des Elements ist der Escape-Handler auf document; er wird je Instanz angemeldet (anmelden) und
     abgemeldet (abbauen), mehrfacher Aufruf beider ist harmlos. */
  var instanzen = new WeakMap();
  function anmelden(x) {
    if (x.fn) return;
    x.fn = function (e) {
      if (!x.box.isConnected) { abbauen(x); return; } /* raeumt sich selbst auf, falls die Box ohne Ereignis aus der Seite genommen wurde */
      if (e.key === 'Escape' && x.esc) x.esc();
    };
    document.addEventListener('keydown', x.fn);
    escListe.push(x);
  }
  function abbauen(x) {
    if (x.fn) { document.removeEventListener('keydown', x.fn); x.fn = null; }
    escListe = escListe.filter(function (y) { return y !== x; });
  }
  function init(box) {
    var alt = instanzen.get(box);
    if (alt) { if (box.isConnected) anmelden(alt); return; } /* schon aufgebaut: nur den Handler wieder anmelden, falls er abgebaut wurde */
    var inst = { box: box, fn: null, esc: null };
    instanzen.set(box, inst);
    box.dataset.lbVoReady = '1';
    var audio = box.querySelector('audio');
    var btn = box.querySelector('[data-lb-vo-play]');
    var wave = box.querySelector('[data-lb-vo-track]');
    var balken = wave ? wave.querySelectorAll('span') : [];
    var time = box.querySelector('[data-lb-vo-time]');
    var toggle = box.querySelector('[data-lb-vo-toggle]');
    var sheet = box.querySelector('[data-lb-vo-sheet]');
    var zu = box.querySelector('[data-lb-vo-close]');
    var total = parseFloat(box.dataset.lbVoDauer) || 0;
    var bis = -1;

    function setzen() {
      var t = audio.currentTime || 0;
      var p = total ? Math.min(1, t / total) : 0;
      var n = Math.round(p * balken.length) - 1;
      if (n !== bis) {
        var a = Math.min(bis, n) + 1, b = Math.max(bis, n), i;
        for (i = a; i <= b; i++) if (balken[i]) balken[i].classList.toggle('is-on', i <= n);
        bis = n;
      }
      if (time) time.textContent = mmss(t) + ' / ' + mmss(total);
    }

    /* LB Update 291 (Auftrag F06/A12): play() liefert ein Promise. Wird es abgelehnt (Browser blockiert den Start, Datei fehlt oder ist
       nicht abspielbar, pause() kam dazwischen, z. B. beim Farbwechsel), blieb das bisher als "Uncaught (in promise)" in der Konsole und
       der Player in einem unklaren Zustand. Jetzt: Zustand zuruecksetzen (Knopf zeigt wieder Abspielen), Box markieren (data-lb-vo-fehler),
       kein Absturz. Das Transkript bleibt bedienbar. */
    function spielen() {
      var p;
      try { p = audio.play(); } catch (e) { p = null; }
      if (p && typeof p.then === 'function') p.then(function () { box.removeAttribute('data-lb-vo-fehler'); }, function (e) {
        box.classList.remove('is-playing'); btn.setAttribute('aria-label', lbVoT.play);
        if (!e || e.name !== 'AbortError') box.setAttribute('data-lb-vo-fehler', (e && e.name) || 'Error');
      });
    }
    btn.addEventListener('click', function () {
      if (audio.paused) {
        document.querySelectorAll('.lb-vo audio').forEach(function (a) { if (a !== audio) a.pause(); });
        spielen();
      } else audio.pause();
    });
    audio.addEventListener('play', function () { box.classList.add('is-playing'); btn.setAttribute('aria-label', lbVoT.pause); });
    audio.addEventListener('pause', function () { box.classList.remove('is-playing'); btn.setAttribute('aria-label', lbVoT.play); });
    audio.addEventListener('ended', function () { box.classList.remove('is-playing'); });
    /* LB Update 291 (Auftrag F06/A12): Datei nicht ladbar/abspielbar (404, defekt, Netz weg): Zustand zuruecksetzen, sonst bliebe der Knopf auf "Pause" stehen */
    audio.addEventListener('error', function () {
      try { audio.pause(); } catch (e) {}
      box.classList.remove('is-playing'); btn.setAttribute('aria-label', lbVoT.play);
      box.setAttribute('data-lb-vo-fehler', 'MediaError' + (audio.error ? audio.error.code : ''));
    });
    audio.addEventListener('timeupdate', setzen);
    audio.addEventListener('loadedmetadata', function () {
      if (audio.duration && isFinite(audio.duration)) { total = audio.duration; box.dataset.lbVoDauer = total; }
      setzen();
    });

    function springen(x) {
      var r = wave.getBoundingClientRect();
      if (!r.width || !total) return;
      audio.currentTime = Math.min(total, Math.max(0, ((x - r.left) / r.width) * total));
      if (audio.paused) spielen();
      setzen();
    }
    if (wave) {
      wave.addEventListener('click', function (e) { springen(e.clientX); });
      wave.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
      });
    }

    function auf(zeigen) {
      sheet.hidden = !zeigen;
      box.classList.toggle('is-open', zeigen);
      toggle.setAttribute('aria-expanded', zeigen ? 'true' : 'false');
    }
    if (toggle) toggle.addEventListener('click', function () { auf(sheet.hidden); });
    if (zu) zu.addEventListener('click', function () { auf(false); toggle.focus(); });
    /* LB Update 291 (Audit S2-029/S2-012): Der Escape-Handler liegt auf document. Damit er sich bei Farbwechsel ohne Neuladen
       oder neu geladener Sektion (Editor) nicht ansammelt, wird er registriert und in alle() abgemeldet, sobald die
       Sprachnachricht nicht mehr in der Seite steht. */
    inst.esc = function () { if (!sheet.hidden) auf(false); };
    anmelden(inst);

    setzen();
  }
  function alle() {
    /* LB Update 291 (Audit S2-029): Handler entfernter Player abmelden (nur wenn die Box wirklich nicht mehr in der Seite steht) */
    escListe.slice().forEach(function (x) { if (!x.box.isConnected) abbauen(x); });
    /* LB Update 291 (Auftrag F06): ein Fehler in einem Player darf die uebrigen nicht blockieren (init merkt sich die Instanz vor dem Aufbau) */
    document.querySelectorAll('.lb-vo').forEach(function (b) { try { init(b); } catch (e) { try { if (window.console) console.warn('lb-voiceover: Aufbau fehlgeschlagen', e); } catch (z) {} } });
  }
  /* LB Update 291 (Auftrag F06): Im Theme-Editor wird eine Sektion zuerst entladen (shopify:section:unload), dann neu geladen. Die Handler der
     darin liegenden Player werden schon beim Entladen abgemeldet, nicht erst beim naechsten Aufbau. */
  function entladen(e) {
    var s = e && e.target;
    if (!s || !s.contains) return;
    escListe.slice().forEach(function (x) { if (s.contains(x.box)) abbauen(x); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle, { once: true });
  else alle();
  document.addEventListener('shopify:section:load', alle);
  document.addEventListener('shopify:section:unload', entladen);
  /* LB Update 263: nach dem Farbwechsel ohne Neuladen (lb-swatch-wechsel.js) die Sprachnachricht der neuen Farbe starten */
  document.addEventListener('lb:produkt-gewechselt', alle);

  /* LB Update 225 (Sascha): Sprachnachricht und Produktvideo laufen nie gleichzeitig.
     Startet das eine, wird das andere pausiert - nicht gestoppt, die Stelle bleibt,
     beim erneuten Abspielen geht es dort weiter. Beide Player reagieren schon auf
     "pause" (Knopf/Overlay stimmen danach). "play" blubbert nicht, daher Capture. */
  if (!window.lbVoVideoExklusiv) {
    window.lbVoVideoExklusiv = true;
    document.addEventListener('play', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      var andere = t.matches('.lb-vo audio') ? '.lb-pvideo__v' : t.matches('.lb-pvideo__v') ? '.lb-vo audio' : '';
      if (!andere) return;
      document.querySelectorAll(andere).forEach(function (m) { if (!m.paused) m.pause(); });
    }, true);
  }
})();
